import { render, staticRenderFns } from "./regis-edit-v3.vue?vue&type=template&id=0e0a33d0&scoped=true"
import script from "./regis-edit-v3.vue?vue&type=script&lang=ts"
export * from "./regis-edit-v3.vue?vue&type=script&lang=ts"
import style0 from "./regis-edit-v3.vue?vue&type=style&index=0&id=0e0a33d0&prod&lang=scss&scoped=true"
import style1 from "./regis-edit-v3.vue?vue&type=style&index=1&id=0e0a33d0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e0a33d0",
  null
  
)

export default component.exports